import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para lidar com erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Redirecionar para login se o token expirar (401)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API de chat
export const chatApi = {
  getChats: () => api.get('/chat'),
  createChat: (title) => api.post('/chat', { title }),
  getChatMessages: (chatId) => api.get(`/chat/${chatId}/messages`),
  sendMessage: async (chatId, content, file) => {
    console.log('API sendMessage chamada com:', { chatId, content, file });
    
    // Se houver arquivo, envie o fileId (após preprocess)
    if (file && file.preprocessed && file.preprocessed.fileId) {
      console.log('Enviando com fileId:', file.preprocessed.fileId);
      return api.post(`/chat/${chatId}/messages`, {
        content,
        fileId: file.preprocessed.fileId
      });
    }
    
    console.log('Enviando sem arquivo');
    return api.post(`/chat/${chatId}/messages`, { content });
  },
  editMessage: (chatId, messageId, content) => api.put(`/chat/${chatId}/messages/${messageId}`, { content }),
  updateChat: (chatId, title) => api.put(`/chat/${chatId}`, { title }),
  deleteChat: (chatId) => {
    console.log('Deletando chat:', chatId);
    return api.delete(`/chat/${chatId}`); // Corrigido: use 'api' e não 'axios'
  },
  regenerateMessage: (chatId, messageId) => api.post(`/chat/${chatId}/regenerate/${messageId}`),
};

// API de upload de arquivos
export const uploadApi = {
  // Pré-processar arquivo antes de enviar mensagem
  preprocessFile: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/preprocess', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteFile: (fileId) => api.delete(`/upload/${fileId}`),
};

// API de arquivos gerados
export const filesApi = {
  downloadGeneratedFile: async (filename) => {
    // Faz a requisição autenticada para obter o arquivo
    const response = await api.get(`/files/download/generated/${filename}`, {
      responseType: 'blob', // Essencial para lidar com dados de arquivo
    });
    return response;
  }
};

// API de administração
export const adminApi = {
  getUsers: () => api.get('/admin/users'),
  createUser: (userData) => api.post('/admin/users', userData),
  updateUser: (userId, userData) => api.put(`/admin/users/${userId}`, userData),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
};

export default api;
